// API Configuration
const API_CONFIG = {
  // Base URLs
  BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:5002",
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: "/auth/login",
      LOGOUT: "/auth/logout",
    },
    
    // General
    GENERAL: {
      USER: "/general/user",
      DASHBOARD: "/general/dashboard",
    },
    
    // Client
    CLIENT: {
      PRODUCTS: "/client/products",
      CUSTOMERS: "/client/customers",
      TRANSACTIONS: "/client/transactions",
      GEOGRAPHY: "/client/geography",
    },
    
    // Sales
    SALES: {
      SALES: "/sales/sales",
    },
    
    // Management
    MANAGEMENT: {
      ADMINS: "/management/admins",
      PERFORMANCE: "/management/performance",
    },
    
    // Time Management
    TIME_MANAGEMENT: {
      EMPLOYEES: "/timeManagement/employees",
      SHIFTS: "/timeManagement/shifts",
      AVAILABILITIES: "/timeManagement/availabilities",
      TIME_OFF_REQUESTS: "/timeManagement/time-off-requests",
      FOOTPRINTS: "/timeManagement/footprints",
      SHIFT_ACTIVITIES: {
        CLOCKINGS: "/timeManagement/shift-activities/clockings",
        BREAKS: "/timeManagement/shift-activities/breaks",
        WEEKLY_SUMMARY: "/timeManagement/shift-activities/weekly-summary",
      },
      ANALYTICS: {
        LABOR_COSTING: "/timeManagement/analytics/labor-costing",
        OVERTIME_EXCEPTIONS: "/timeManagement/analytics/overtime-exceptions",
        PRODUCTIVITY_ATTENDANCE: "/timeManagement/analytics/productivity-attendance",
      },
    },
  },
  
  // HTTP Methods
  METHODS: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH",
  },
  
  // Default Headers
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  
  // Request Timeout
  TIMEOUT: 10000,
  
  // Status Codes
  STATUS_CODES: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },
  
  // Cache Tags for RTK Query
  CACHE_TAGS: [
    "Login",
    "User",
    "Products",
    "Customers",
    "Transactions",
    "Geography",
    "Sales",
    "Admins",
    "Performance",
    "Dashboard",
    "Footprints",
    "Shifts",
    "Availabilities",
    "TimeOffRequests",
  ],
};

// Helper function to build full URL
export const buildUrl = (endpoint, params = {}) => {
  const url = new URL(endpoint, API_CONFIG.BASE_URL);
  
  // Add query parameters
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      url.searchParams.append(key, params[key]);
    }
  });
  
  return url.toString();
};

// Helper function to get authorization header
export const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Helper function to build request headers
export const buildHeaders = (additionalHeaders = {}) => ({
  ...API_CONFIG.DEFAULT_HEADERS,
  ...getAuthHeader(),
  ...additionalHeaders,
});

export default API_CONFIG; 